

































































import { Component, Vue } from 'vue-property-decorator';
import {BlindsState, WhiteBoardState, ClockState, MoodState, TalkToPatientState, Locale} from "@/store/store";
import StoreDebugValue from "@/components/StoreDebugValue.vue";
import VideoPlayer from '@/components/VideoPlayer.vue';
import GameLogic from "../services/GameLogic";

@Component({
    components: {VideoPlayer, StoreDebugValue},
    computed: {
        scoreValue():string {
            const score = this.$store.state.dayState.score;
            const situation = GameLogic.getSituationObject(this.$store.state);
            const minmax = situation.situation.score;
            if( score < minmax.min ) {
                return [score, ' (min ', minmax.min, ' voor zelfde mood)'].join('');
            } else if( score < minmax.max) {
                return [score, ' (min ', minmax.max, ' voor betere mood)'].join('');
            } else {
                return [score, ' (betere mood)'].join('');
            }
        },
        situationValue():string {
            return this.$store.getters.situation + '';
        },
        patientStateValue():string {
            return [
                this.$store.state.communicateState
                // TalkToPatientState[this.$store.state.comm],
                // ' (',
                // this.$store.state.dayState.talkedToPatientState,
                // ')'
            ].join('');
        },
        dayValue():string {
            return this.$store.state.day + '';
        },
        curtainsValue():string {
            return BlindsState[this.$store.state.blinds];
        },
        whiteBoardValue():string {
            return WhiteBoardState[this.$store.state.whiteBoard];
        },
        clockValue():string {
            return ClockState[this.$store.state.clock];
        },
        moodValue():string {
            return MoodState[this.$store.state.mood];
        },
        localeValue():string {
            return this.$store.state.locale;
        },
        clocksValue():string {
            const dayState = this.$store.state.dayState;
            return [dayState.turnsLeft, '/', dayState.turnBudget].join('');
        }
    },
    props: {

    },
    methods: {
        resetGame():void {
            this.$store.commit('resetGame');
            this.$store.commit('startDay');
            this.$router.push('/');
        },
        startDay():void {
            this.$store.commit('startDay');
        },
        nextDay(): void {
            GameLogic.nextDay(this.$router, this.$store);
        },
        switchNl():void {
            this.$store.state.locale = Locale.nl;
        },
        switchEn():void {
            this.$store.state.locale = Locale.en;
        },
        switchDay(day:number):void {
            this.$store.state.day = day;
            this.$router.push('/day/' + day);
        },
        randomTestRun():void {
            this.$data.testResults = GameLogic.executeRandomTestRun(this.$store);
            this.$router.push('/end');
        },
        clearTestRun():void {
            this.$data.testResults = [];
        },
        testRun(key:string):void {
            this.$data.testResults = GameLogic.executeTestRun(this.$store, key);
            this.$router.push('/end');
        }
    },
    data: function() { return { testResults:[] }; }
})
export default class StoreDebug extends Vue {
}
